/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Directive, ElementRef, Renderer, AfterViewInit } from '@angular/core';
import { Inject, Optional, Host, forwardRef } from '@angular/core';

import { Table } from './table';
/**
 * 表格：tbody
 */
export class TableContentBody implements AfterViewInit {
/**
 * 样式前缀
 * @return {?}
 */
get prefixCls(): string {
        return this.table && this.table.prefixCls || '';
    }
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} table
 */
constructor(
private _renderer: Renderer,
private _elementRef: ElementRef,
private table: Table) {

    }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
        const /** @type {?} */ el = this._elementRef.nativeElement;
        this._renderer.setElementClass(el, `${this.prefixCls}-tbody`, true);
    }


static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    // tslint:disable-next-line:directive-selector
    selector: 'tbody'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Table, decorators: [{ type: Inject, args: [forwardRef(() => Table), ] }, { type: Optional }, { type: Host }, ]},
];
}

function TableContentBody_tsickle_Closure_declarations() {
/** @type {?} */
TableContentBody.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TableContentBody.ctorParameters;
/** @type {?} */
TableContentBody.prototype._renderer;
/** @type {?} */
TableContentBody.prototype._elementRef;
/** @type {?} */
TableContentBody.prototype.table;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
